import { clientsAPI } from 'api/clientsAPI'
import { useQuery } from '@tanstack/react-query'

export default function useBookingReferences(clientId?: number) {
  const query = useQuery({
    queryKey: ['fetchBookingReferences', clientId],
    queryFn: () => clientsAPI.getBookingReferences(clientId!),
    enabled: Boolean(clientId),
    keepPreviousData: false,
    refetchOnMount: true,
  })

  const isLoading = query.isLoading || query.isFetching
  const bookingReferences = query.data?.data?.value ?? []

  return {
    bookingReferences,
    ...query, // spreads the old isLoading
    isLoading, // _then_ override it with your combined flag
  }
}
